<template>
  <div>
    <el-drawer
      :visible.sync="show"
      :with-header="false"
      :before-close="handleClose"
      :modal="true"
      :wrapperClosable="false"
    >
      <div class="createdrawer_box" v-loading="loading">
        <div class="createdrawer_body">
          <div class="form-wrap">
            <div class="form">
              <div class="form__header">
                <div>
                  <span class="text-bold">{{ title }}</span>
                </div>
                <div class="header_btn">
                  <el-button
                    class="closedrawerbtn"
                    type="text"
                    icon="el-icon-close"
                    @click="handleClose"
                  ></el-button>
                </div>
              </div>
              <div
                class="form_field"
                :style="{ height: windowHeight - 100 + 'px' }"
              >
                <div class="form_left">
                  <div v-for="(item, index) in createlist" style="margin-bottom: 23px">
                    <label class="tit_left"
                      ><i
                        class="el-icon-collection-tag"
                        style="
                          font-size: 12px;
                          color: #2b75ebff;
                          margin-right: 8px;
                        "
                      ></i
                      >{{ item.name || "" }}</label
                    >
                    <div class="form_item_left">
                      <template
                        v-for="value in fieldlist"
                        v-if="value.type == item.type && value.is_show"
                      >
                        <div class="items" v-if="value.field_type === 1">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          <el-input
                            clearable
                            :maxlength="value.maxLength"
                            :disabled="value.disabled"
                            v-model="value.content"
                            :placeholder="value.placeholder"
                            :class="
                              value.length === 1
                                ? 'input_w230'
                                : value.length === 0
                                ? 'input_w460'
                                : value.length === 2
                                ? 'input_w690'
                                : value.length === 3
                                ? 'input_w920'
                                : 'input_w460'
                            "
                          >
                          </el-input>
                        </div>
                        <div class="items" v-else-if="value.field_type === 2">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          <el-input
                            clearable
                            :maxlength="value.maxLength"
                            :disabled="value.disabled"
                            type="textarea"
                            :rows="1"
                            v-model="value.content"
                            :placeholder="value.placeholder"
                            :class="
                              value.length === 1
                                ? 'input_w230'
                                : value.length === 0
                                ? 'input_w460'
                                : value.length === 2
                                ? 'input_w690'
                                : value.length === 3
                                ? 'input_w920'
                                : 'input_w460'
                            "
                            style="height: auto"
                          >
                          </el-input>
                        </div>
                        <div class="items" v-else-if="value.field_type === 3">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          <el-date-picker
                            v-model="value.content"
                            :disabled="value.disabled"
                            value-format="timestamp"
                            type="date"
                            :placeholder="value.placeholder"
                            :class="
                              value.length === 1
                                ? 'input_w230'
                                : value.length === 0
                                ? 'input_w460'
                                : value.length === 2
                                ? 'input_w690'
                                : value.length === 3
                                ? 'input_w920'
                                : 'input_w460'
                            "
                          >
                          </el-date-picker>
                        </div>
                        <div class="items" v-else-if="value.field_type === 4">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          <el-input
                            clearable
                            :maxlength="value.maxLength"
                            :disabled="value.disabled"
                            v-model="value.content"
                            :placeholder="value.placeholder"
                            :class="
                              value.length === 1
                                ? 'input_w230'
                                : value.length === 0
                                ? 'input_w460'
                                : value.length === 2
                                ? 'input_w690'
                                : value.length === 3
                                ? 'input_w920'
                                : 'input_w460'
                            "
                            oninput="value=value.replace(/[^0-9.]/g,'')"
                          >
                          </el-input>
                        </div>
						<div class="items" v-else-if="value.field_type === 18">
						  <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
						  <template >
						    <el-select
						      v-model="value.content"
						      :disabled="value.disabled"
						      :placeholder="value.placeholder"
						      :class="
						        value.length === 1
						          ? 'input_w230'
						          : value.length === 0
						          ? 'input_w460'
						          : value.length === 2
						          ? 'input_w690'
						          : value.length === 3
						          ? 'input_w920'
						          : 'input_w460'
						      "
						      @change="handleSwitch(value.content)"
						    >
						      <el-option
						        v-for="(item2, index2) in value.field_list"
						        :key="item2.form_id"
						        :label="item2.name"
						        :value="item2.form_id"
						      >
						      </el-option>
						    </el-select>
						  </template>
						  
						</div>
						
                        <div class="items" v-else-if="value.field_type === 5">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          
                          <template >
                            <el-select
                              v-model="value.content"
                              :disabled="value.disabled"
                              :placeholder="value.placeholder"
                              :class="
                                value.length === 1
                                  ? 'input_w230'
                                  : value.length === 0
                                  ? 'input_w460'
                                  : value.length === 2
                                  ? 'input_w690'
                                  : value.length === 3
                                  ? 'input_w920'
                                  : 'input_w460'
                              "
                            >
                              <el-option
                                v-for="(item2, index2) in value.field_list"
                                :key="item2.id"
                                :label="item2.name"
                                :value="item2.id"
                              >
                              </el-option>
                            </el-select>
                          </template>
                        </div>
                        
						<div class="items" v-else-if="value.field_type === 6">
                          <label class="tit">{{ value.field }}<i v-if="value.required == 1" style="color: red">*</i></label>
                          <el-select
                            multiple
                            collapse-tags
                            v-model="value.content"
                            :disabled="value.disabled"
                            :placeholder="value.placeholder"
                            :class="
                              value.length === 1
                                ? 'input_w230'
                                : value.length === 0
                                ? 'input_w460'
                                : value.length === 2
                                ? 'input_w690'
                                : value.length === 3
                                ? 'input_w920'
                                : 'input_w460'
                            "
                          >
                            <el-option
                              v-for="(item2, index2) in value.field_list"
                              :key="item2.id"
                              :label="item2.name"
                              :value="item2.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 7">
                          <label class="tit">{{ value.field }}</label>
                          <enclofile
                            :ispowerDel="ispowerDel"
                            :disabled="value.disabled"
                            :enclist="value.content"
                            :fieldid="value.id"
                            @fndelet="fndelet"
                            :filenum="value.field_list.fileNum"
                            :filesize="value.field_list.fileSize"
                            @setupfile="setupfile"
                          >
                          </enclofile>
                        </div>
                        <div class="items" v-else-if="value.field_type === 8">
                          <label class="tit">{{ value.field }}</label>
                          <enclofile
                            :ispowerDel="ispowerDel"
                            :disabled="value.disabled"
                            :enclist="value.content"
                            :fieldid="value.id"
                            :filenum="value.field_list.imgNum"
                            @fndelet="fndelet"
                            @setupfile="setupfile"
                            accept=".png,.jpg,.jpeg"
                          >
                          </enclofile>
                        </div>
                        <div class="items" v-else-if="value.field_type === 9">
                          <label class="tit">{{ value.field }}</label>
                          <addproduct
                            :ispowerEdit="ispowerEdit"
                            :ispowerDel="ispowerDel"
                            :islook="value.is_show"
                            :isedit="!value.disabled"
                            :isnodata="false"
                            :show="show"
                            :disabled="value.disabled"
                            :pro_list="value.content"
                            :fieldid="value.id"
                            @eidht="headeidht"
                            @deleteds="headdeleteds"
                            @pushpro="headpushpro"
                            @procomkl="headprocomkl"
                          ></addproduct>
                        </div>
                        <div class="items" v-else-if="value.field_type === 10">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            filterable
                            v-model="value.content"
                            placeholder="请选择"
                            :disabled="value.disabled"
                            class="input_w460"
                          >
                            <el-option
                              v-for="(item2, index2) in member_list"
                              :key="item2.member_id"
                              :label="item2.name"
                              :value="item2.member_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 11">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            v-model="value.content"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            :disabled="value.disabled"
                            placeholder="请选择"
                            class="input_w460"
                          >
                            <el-option
                              v-for="(item2, index2) in member_list"
                              :key="item2.member_id"
                              :label="item2.name"
                              :value="item2.member_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 12">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            v-model="value.content"
                            filterable
                            placeholder="请选择"
                            class="input_w460"
                            :disabled="value.disabled"
                            @change="changeCustomer"
                          >
                            <el-option
                              v-for="(item2, index2) in CustomerList"
                              :key="item2.customer_id"
                              :label="item2.customer_name"
                              :value="item2.customer_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 13">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            v-model="value.content"
                            clearable
                            :disabled="value.disabled"
                            filterable
                            class="input_w460"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item2, index2) in chance_list"
                              :key="item2.chance_id"
                              :label="item2.name"
                              :value="item2.chance_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 14">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            :disabled="value.disabled"
                            clearable
                            v-model="value.content"
                            filterable
                            class="input_w460"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item2, index2) in contract_list"
                              :key="item2.contract_id"
                              :label="item2.name"
                              :value="item2.contract_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" v-else-if="value.field_type === 17">
                          <label class="tit">{{ value.field }}</label>
                          <el-select
                            :disabled="value.content ? false : contact_disabled"
                            clearable
                            v-model="value.content"
                            filterable
                            class="input_w460"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item2, index2) in contactslist"
                              :key="item2.contact_id"
                              :label="item2.name"
                              :value="item2.contact_id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="items" style="min-width: 900px;" v-else-if="value.field_type === 15">
                          <div class="consactzs">
                            <div class="tit">类型</div>
                            <div>
                              <el-radio
                                v-if="value.cue_show"
                                v-model="value.relation_type"
                                :label="1"
                                :disabled="value.cue_disabled"
                                >线索</el-radio
                              >
                              <el-radio
                                v-if="value.customer_show"
                                v-model="value.relation_type"
                                :label="2"
                                :disabled="value.customer_disabled"
                                >客户</el-radio
                              >
                            </div>
                          </div>
                          <div
                            class="consactzs"
                            v-show="value.relation_type == 1"
                            v-if="value.cue_show"
                          >
                            <div class="tit">关联线索</div>
                            <el-select
                              v-model="value.cue_id"
                              clearable
                              filterable
                              placeholder="请选择"
                              @change="cueChange($event, index)"
                              :disabled="value.cue_disabled"
                              class="input_w460"
                            >
                              <el-option
                                v-for="(item2, index2) in clue_list"
                                :key="item2.cue_id"
                                :label="item2.name"
                                :value="item2.cue_id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div
                            class="consactzs"
                            v-show="value.relation_type == 2"
                            v-if="value.customer_show"
                          >
                            <div class="tit">关联客户:</div>
                            <el-select
                              v-model="value.customer_id"
                              clearable
                              filterable
                              @change="CustomerChange($event, index)"
                              placeholder="请选择"
                              :disabled="value.customer_disabled"
                              class="input_w460"
                            >
                              <el-option
                                v-for="(item2, index2) in CustomerList"
                                :key="item2.customer_id"
                                :label="item2.name1"
                                :value="item2.customer_id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <div class="items" v-else-if="value.field_type === 16">
                          <div
                            class="consactzs"
                            v-if="value.checkshow"
                            style="width: 920px; margin-top: 20px"
                          >
                            <el-checkbox
                              el-checkbox
                              :disabled="true"
                              v-model="checksed"
                            >
                              创建联系人
                            </el-checkbox>
                          </div>
                        </div>
                        <template v-for="(lx_item, lx_index) in value.lxr_list">
                          <div class="items" v-if="lx_item.field_type == 1 && lx_item.is_show">
                            <label class="tit">{{ lx_item.field }}<i v-if="lx_item.required == 1" style="color: red">*</i></label>
                            <el-input
                              :maxlength="lx_item.maxLength"
                              :disabled="lx_item.lxr_checked"
                              v-model="lx_item.content"
                              placeholder="请输入"
                              class="input_w460"
                            >
                            </el-input>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 2">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-input
                              :maxlength="lx_item.maxLength"
                              :disabled="lx_item.lxr_checked"
                              type="textarea"
                              :rows="1"
                              placeholder="请输入"
                              v-model="lx_item.content"
                              class="input_w460"
                              style="color: #606266; height: auto"
                            >
                            </el-input>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 3">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-date-picker
                              v-model="lx_item.content"
                              :disabled="lx_item.lxr_checked"
                              value-format="timestamp"
                              type="date"
                              placeholder="选择日期"
                              class="input_w460"
                            >
                            </el-date-picker>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 4">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-input
                              :maxlength="lx_item.maxLength"
                              :disabled="value.lxr_checked"
                              v-model="lx_item.content"
                              placeholder="请输入内容"
                              oninput="value=value.replace(/[^0-9.]/g,'')"
                              class="input_w460"
                            >
                            </el-input>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 5">
                            <label class="tit">{{ lx_item.field }}  
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-select
                              v-model="lx_item.content"
                              :disabled="lx_item.lxr_checked"
                              class="input_w460"
                            >
                              <el-option
                                v-for="(item2, index2) in lx_item.field_list"
                                :key="item2.name"
                                :label="item2.name"
                                :value="item2.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 6">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-select
                              multiple
                              collapse-tags
                              v-model="lx_item.content"
                              :disabled="lx_item.lxr_checked"
                              class="input_w460"
                            >
                              <el-option
                                v-for="(item2, index2) in lx_item.field_list"
                                :key="item2.name"
                                :label="item2.name"
                                :value="item2.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 7">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <enclofile
                              :disabled="lx_item.lxr_checked"
                              :enclist="lx_item.content"
                              :fieldid="lx_item.id"
                              @fndelet="fndelet"
                              :filenum="lx_item.field_list.fileNum"
                              :filesize="lx_item.field_list.fileSize"
                              @setupfile="setupfile"
                            >
                            </enclofile>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 8">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <enclofile
                              :disabled="lx_item.lxr_checked"
                              :enclist="lx_item.content"
                              :fieldid="lx_item.id"
                              :filenum="lx_item.field_list.imgNum"
                              @fndelet="fndelet"
                              @setupfile="setupfile"
                              accept=".png,.jpg,.jpeg"
                            >
                            </enclofile>
                          </div>
                          <div class="items" v-if="lx_item.field_type == 11">
                            <label class="tit">{{ lx_item.field }}
							<i v-if="lx_item.required == 1" style="color: red">*</i>
							</label>
                            <el-select
                              v-model="lx_item.content"
                              clearable
                              filterable
                              multiple
                              collapse-tags
                              :disabled="lx_item.lxr_checked"
                              placeholder="请选择"
                              class="input_w460"
                            >
                              <el-option
                                v-for="(item2, index2) in member_list"
                                :key="item2.member_id"
                                :label="item2.name"
                                :value="item2.member_id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form_submit">
                <div class="form_submit_buttons1">
                  <el-button @click="create_saveer(false)">保存</el-button>
                </div>
                <div class="form_submit_buttons2">
                  <el-button
                    style="width: 100px"
                    @click="create_saveer(true)"
                    v-if="savenew"
                    >保存并新建</el-button
                  >
                  <el-button
                    style="width: 60px; margin-left: 8px"
                    @click="handleClose"
                    >取消</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="提示"
      :visible.sync="queryshow"
      width="245px"
      :show-close="show_closer"
      :close-on-click-modal="close_modal"
      :close-on-press-escape="close_press"
      :lock-scroll="lock_scrol"
      :before-close="handlequery"
      :modal-append-to-body="false"
    >
      <div class="queryobx">
        <div class="query_top">
          <div class="tit">系统中存在相同的公司</div>
          <div class="txt">点击查看可查看详细信息</div>
        </div>
        <div class="query_bottom">
          <div class="query_btn btn1" @click="chakan">查看</div>
          <div class="query_line"></div>
          <div class="query_btn btn2" @click="handlequery">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var that;
import addproduct from "components/content/addproduct/addproduct";
import enclofile from "components/content/addproduct/enclofile";

import {
  get_membelist,
  gchance_list,
  get_contracTlist,
  getuser_info,
} from "network/hk_operset";
import {
  getCustomerList,
  getlistCuePools,
  lxr_list2confield,
  getfollow_up_list,
  getCustList2,
} from "network/hk_customer";

import {
  kh_customer_list,
  xs_cue_pool_list,
  handlereq,
  alertMess,
  lxrl_list_contact,
} from "network/kh_public";
export default {
  name: "newfieldcreate",
  components: {
    addproduct,
    enclofile,
  },
  props: {
    ispowerEdit: {
      type: Boolean,
      default: true,
    },
    ispowerDel: {
      type: Boolean,
      default: true,
    },

    savenew: {
      type: Boolean,
      default: false,
    },

    createlist: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //
    createlist: {
      type: Array,
      default: () => {
        return [];
      },
    },
    fieldlist: {
      type: Array,
      default: () => {
        return [];
      },
    },

    width: {
      type: String,
      default: "916px",
    },
    title: {
      type: String,
      default: "新建",
    },
    show: {
      type: Boolean,
      default: false,
    },
    // 是否获取全部客户
    allCusts: {
      type: Boolean,
      default: false,
    },
    // 有什么 创建关联 1: 商机， 2: 合同；
    isrelation: {
      type: Number,
      default: 0,
    },

    // 基础数据 是否加载完成
    loading: {
      type: Boolean,
      default: true,
    },

    // 是否显示关闭按钮
    show_closer: {
      type: Boolean,
      default: true,
    },
    // 是否可以通过点击 modal 遮罩层 关闭 Dialog
    close_modal: {
      type: Boolean,
      default: false,
    },
    // 是否可以通过按下 ESC 关闭 Dialog
    close_press: {
      type: Boolean,
      default: true,
    },
    // 是否在 Dialog 出现时将 body 滚动锁定
    lock_scrol: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      click_flag: true,

      checksed: true,

      restaurants: [],

      lxr_checked: false,

      create_page: 0,

      urlhead: "https://scrm.51kuaiding.com/scrm/hktxcx/customer",

      member_list: [],
      CustomerList: [],
      chance_list: [],
      contract_list: [],

      clue_list: [],

      chance_charge: true,
      contract_charge: true,

      member_id: "",

      lxr_list: [],
      source_select: [],
      lxr_loading: false,

      query: [],
      queryshow: false,
      search_name: "",

      contactslist: [],
      contact_disabled: true,
      windowHeight: window.innerHeight,
    };
  },
  created() {
    that = this;
  },

  watch: {
    show() {
      if (!this.show) {
        this.contactslist = [];
        this.contact_disabled = true;
      }
    },
    //
    loading() {
      if (!this.loading) {
        this.create_page = 0;
        let flag1 = this.findTpye(10);
        let flag2 = this.findTpye(11);

        setTimeout(() => {
          let flaglxr = this.findTpye(16);
          if (flaglxr) {
            // 获取所有 成员
            this.fn_get_membelist();
          }
        }, 500);
        if (flag1 || flag2) {
          // 获取所有 成员 11
          this.fn_get_membelist();
        }
        let flag3 = this.findTpye(12);
        if (flag3) {
          this.fn_getuser();
        }

        let index2 = this.fieldlist.findIndex((v) => v.field_type == 12);
        if (index2 != -1) {
          let customer_id = this.fieldlist[index2].content * 1;

          if (customer_id) {
            let flag4 = this.findTpye(13);
            if (flag4) {
              // 获取 关联商机
              this.fn_gchance_list(customer_id);
              let lindex = this.fieldlist.findIndex((v) => v.field_type == 13);
              if (lindex != -1) {
                let disableds = this.fieldlist[lindex].disableds;
                if (disableds) {
                  this.chance_charge = true;
                }
              }
            }

            let flag5 = this.findTpye(14);
            if (flag5) {
              // 获取 关联合同
              this.fn_contract_list(customer_id);
            }
          }
        }

        //
        let flag_cons = this.findTpye(15);
        if (flag_cons) {
          this.fn_getuser();
        }
        //

        //
        //
        let customer = this.fieldlist.some((v) => v.field == "客户名称");
        if (customer) {
          this.fn_getCoruter();
        }
        //

        // 联系人列表
        if (this.findTpye(17)) {
          let index_1 = this.fieldlist.findIndex((v) => v.field_type == 12);
          if (index_1 != -1 && this.fieldlist[index_1]) {
            let customer_id = this.fieldlist[index_1].content;
            if (typeof customer_id == "number") {
              this.get_contactslist(customer_id);
            }
          }
        }
        //
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    test() {
      console.log(
        console.log(
          "🚀 ~ file: fieldcreate.vue:669 ~ show ~ this.fieldlist:",
          this.fieldlist
        )
      );
    },
    handleResize() {
      this.windowHeight = window.innerHeight;
    },
    cueChange(e, index) {
      this.fieldlist[index].cue_name = "";
      if (e) {
        let flag = this.clue_list.findIndex((v) => v.cue_id == e);
        if (flag != -1) {
          this.fieldlist[index].cue_name = this.clue_list[flag].name;
        }
      }
      this.fieldlist[index].customer_name = "";
    },
    CustomerChange(e, index) {
      this.fieldlist[index].customer_name = "";
      if (e) {
        let flag = this.CustomerList.findIndex((v) => v.customer_id == e);
        if (flag != -1) {
          this.fieldlist[index].customer_name = this.CustomerList[flag].name1;
        }
      }
      this.fieldlist[index].cue_name = "";
    },
    findTpye(field_type) {
      return this.fieldlist.some((v) => v.field_type == field_type);
    },
    chakan() {
      this.handlequery();
      this.handleClose();
      this.$emit("chakan", { query: this.search_name });
    },
    handlequery() {
      this.queryshow = false;
    },

    fn_getCoruter() {
      let data = {
        pagesize: 999,
        sort_type: 1,
        class_type: 0,
      };
      getCustList2(data).then((res) => {
        if (this.handlereq(res)) {
          let obj = res.result.data;
          if (obj.length) {
            for (let item of obj) {
              item.value = item.customer_name;
            }
            this.restaurants = obj;
          }
        }
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      this.query = results;
      this.search_name = queryString;
      // 调用 callback 返回建议列表的数据 customer_name
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    handleSelect(item) {
      this.search_name = item.value;
    },
    // 获取客户来源
    fn_follow_up_list() {
      this.lxr_loading = true;
      this.source_select = [];
      getfollow_up_list().then((res) => {
        if (res.code === 10000) {
          this.source_select = res.result.data;
          this.fn_getlxrlists();
        }
      });
    },

    // 获取联系人 字段 列表 basics_list
    fn_getlxrlists() {
      lxr_list2confield().then((res) => {
        if (res.code === 10000) {
          let obj = res.result;
          if (obj.length) {
            for (let item of obj) {
              //
              let field_sign = item.field_sign;
              let filerlist = ["邮箱", "微信号", "QQ号", "职务"];
              let flagfiler = filerlist.some((v) => v == field_sign);
              if (flagfiler) {
                item.field_type = 1;
              }
              if (field_sign == "联系人姓名") {
                item.field_type = 1;
                item.maxLength = 50;
              } else if (field_sign == "联系人来源") {
                item.field_type = 5;
                item.field_list = this.source_select;
                item.content = this.source_select[0].id;
              } else if (field_sign == "手机") {
                item.field_type = 1;
                item.maxLength = 30;
              } else if (field_sign == "生日") {
                item.field_type = 3;
              } else if (field_sign == "性别") {
                item.field_type = 5;
                item.field_list = [
                  {
                    id: 1,
                    name: "男",
                  },
                  {
                    id: 2,
                    name: "女",
                  },
                ];
                item.content = 1;
              }
              //
            }
            this.lxr_list = obj;
          }
        }
        this.lxr_loading = false;
      });
    },
    //

    // 编辑 / 新建 保存  确认
    create_saveer(flag) {
      if (this.click_flag) {
        this.click_flag = false; // 是否能再次点击
        if (this.query.length) {
          let queryflag = this.query.some((v) => v.value == this.search_name);
          if (queryflag) {
            this.queryshow = true;
          } else {
            let arr = [];
            let index1 = this.fieldlist.findIndex(
              (v) => v.field == "创建联系人"
            );
            if (index1 != -1) {
              arr = this.fieldlist[index1].lxr_list || [];
            }
            this.$emit("saveer", {
              flag,
              arr,
            });
          }
        } else {
          let arr = [];
          let index1 = this.fieldlist.findIndex((v) => v.field == "创建联系人");
          if (index1 != -1) {
            arr = this.fieldlist[index1].lxr_list || [];
          }
          this.$emit("saveer", {
            flag,
            arr,
          });
        }
        setTimeout(() => {
          this.click_flag = true;
        }, 2000);
      } else {
        alertMess("操作过快,稍后再试", "error");
      }
    },
    // 切换客户模板
    handleSwitch(formId) {
      this.$emit("fnswitch", formId);
    },
    handleClose() {
      this.chance_charge = true;
      this.contract_charge = true;
      this.create_page = 0;

      this.clue_list = [];
      this.CustomerList = [];
      this.chance_list = [];
      this.contract_list = [];

      this.$emit("update:show", false);
    },

    // 附件 删除 field_type === 11
    fndelet(e) {
      this.$emit("fjdelet", e);
    },

    // 附件 新增
    setupfile(e) {
      this.$emit("fjadds", e);
    },

    //
    // 产品 ----------------- field_type === 10
    // 编辑确定
    headeidht(e) {
      this.$emit("cpedits", e);
    },
    // 删除确定
    headdeleteds(e) {
      this.$emit("cpdelet", e);
    },
    // 自定义产品 确定
    headpushpro(e) {
      this.$emit("cppush", e);
    },
    // 选择产品 确定
    headprocomkl(e) {
      this.$emit("cpcomk", e);
    },
    // -----------------

    setlist(type, obj) {
      let index = this.fieldlist.findIndex((v) => v.field_type == type);
      if (index != -1 && this.fieldlist[index]) {
        this.fieldlist[index].field_list = obj;
      }
    },
    // 获取所有 成员
    fn_get_membelist() {
      get_membelist().then((res) => {
        if (this.handlereq(res)) {
          let obj = res.result.data;

          for (let item of obj) {
            item.id = item.member_id;
          }
          this.member_list = obj;

          this.setlist(10, obj);
          this.setlist(11, obj);
          let lindex3 = this.fieldlist.findIndex((v) => v.field_type == 16); // 创建联系人
          if (lindex3 != -1 && this.fieldlist[lindex3]) {
            let list = this.fieldlist[lindex3].lxr_list;
            let lindex4 = list.findIndex((v) => v.field_type == 11); // 协同人
            if (lindex4 != -1 && list[lindex4]) {
              list[lindex4].field_list = obj;
            }
          }
        }
      });
    },
    // 获取个人信息
    fn_getuser() {
      let memberid = this.$store.state.member_id || localStorage.member_id;
      if (memberid) {
        this.member_id = memberid * 1;
        // 获取客户列表
        this.fn_getCusList();

        //
        let flag_con2 = this.findTpye(15);
        if (flag_con2) {
          this.getcluelists();
        }
        //
      } else {
        getuser_info().then((res) => {
          if (this.handlereq(res)) {
            let { member_id, member_name, store_id } = res.result;
            localStorage.setItem("member_id", member_id);
            localStorage.setItem("member_name", member_name);
            this.member_id = member_id * 1;
            this.member_name = member_name;
            that.$store.commit("setMemberId", member_id);
            that.$store.commit("setMemberName", member_name);
            // 获取客户列表
            this.fn_getCusList();
            //
            let flag_con2 = this.findTpye(15);
            if (flag_con2) {
              this.getcluelists();
            }
            //
          }
        });
      }
    },
    // 获取线索列表
    getcluelists() {
      let data = {
        pagesize: 999,
        page: 1,

        sort_type: 1,
        class_type: 0,
      };
      if (this.allCusts) {
        // 获取 指定所属人 客户
        data.class_type = 1;
      }
      // getlistCuePools
      xs_cue_pool_list(data).then((res) => {
        if (this.handlereq(res)) {
          this.clue_list = res.result.data;
        }
      });
    },

    // 获取客户列表
    fn_getCusList() {
      let data = {
        sort_type: 1, //  否	string	排序类型 1:最新释放2:最新创建3:最新访问4:最新跟进
        pagesize: 999, //  	是	int	每页数量
        page: 1,
        class_type: 0,
      };
      if (this.allCusts) {
        // 获取 指定所属人 客户 我负责的
        data.class_type = 1;
      }
      kh_customer_list(data).then((res) => {
        if (this.handlereq(res)) {
          let list = res.result.data || [];
          this.CustomerList = list;

          for (let item of list) {
            item.id = item.customer_id;
          }
          this.setlist(12, list);
        }
      });
    },

    // 选择客户后
    changeCustomer(customer_id) {
      let flag1 = this.findTpye(13);
      let flag2 = this.findTpye(14);
      let flag3 = this.findTpye(17);

      if (customer_id) {
        // 获取 当前客户的 关联-商机、合同
        if (this.isrelation == 1 && flag1) {
          // 商机
          this.fn_gchance_list(customer_id);
        } else if (this.isrelation == 2 && flag2) {
          // 合同
          this.fn_contract_list(customer_id);
        }
        if (flag3) {
          // 选择联系人
          let index_1 = this.fieldlist.findIndex((v) => v.field_type == 17);
          if (index_1 != -1 && this.fieldlist[index_1]) {
            this.fieldlist[index_1].content = "";
          }
          this.get_contactslist(customer_id);
        }
      }
    },
    // 获取联系人列表
    get_contactslist(customer_id) {
      let data = {
        sort_type: 1,
        pagesize: 999,
        page: 1,
        customer_id,
      };
      lxrl_list_contact(data).then((res) => {
        if (this.handlereq(res)) {
          let list = res.result.data || [];
          this.contactslist = list;
          this.contact_disabled = false;

          for (let item of list) {
            item.id = item.contact_id;
          }
          this.setlist(17, list);
        }
      });
    },
    // 获取 商机 列表
    fn_gchance_list(customer_id) {
      let data = {
        pagesize: 999,
        page: 1,
        customer_id,
        is_recycle: 0,
      };
      gchance_list(data).then((res) => {
        if (this.handlereq(res)) {
          let list = res.result.data || [];
          this.chance_list = list;
          this.chance_charge = false;

          for (let item of list) {
            item.id = item.chance_id;
          }
          this.setlist(13, list);
        }
      });
    },
    // 获取 合同 列表
    fn_contract_list(customer_id) {
      let data = {
        pagesize: 999,
        page: 1,
        customer_id,
        is_recycle: 0,
      };
      get_contracTlist(data).then((res) => {
        if (this.handlereq(res)) {
          let list = res.result.data || [];
          this.contract_list = list;
          this.contract_charge = false;

          for (let item of list) {
            item.id = item.contract_id;
          }
          this.setlist(14, list);
        }
      });
    },

    // 弹出提示
    alertMess(message, type) {
      this.$message({
        showClose: true,
        offset: 100,
        duration: 2000,
        message,
        type: type ? type : "success",
      });
    },
    handlereq(res) {
      if (res) {
        if (res.code === 10000) {
          // 请求成功
          return true;
        } else {
          // 请求发生错误
          this.alertMess(res.message, "error");
          return false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
	
/deep/ .el-drawer__wrapper {
}
/deep/ .el-drawer {
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2) !important;
  border-top: 1px solid #dadee3;
  z-index: 999;
}
.createdrawer_box {
  height: 100%;
  min-width: 1000px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-items: stretch;
  overflow: auto;
}
.createdrawer_body {
  padding: 0;
  position: relative;
  flex: auto;
  overflow: auto;
}
.form-wrap {
  margin-right: 0;
  height: 100%;
  position: relative;
}
.form {
  margin-left: 0;
  display: flex;
  overflow: hidden;
  padding: 0;
  height: 100%;
}
.form__header {
  background-color: #fff;
  border-bottom: 1px solid #dadee3;
  height: 52px;
  left: 0;
  padding: 0 30px 0 30px;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  display: flex;
  .header_btn {
    width: 24px;
    height: 24px;
    .el-button.closedrawerbtn {
      padding: 0;
      align-items: center;
      background: none;
      border: 0;
      cursor: pointer;
      display: flex;
      flex: none;
      font-size: 24px;
      justify-content: center;
      position: absolute;
      z-index: 1;
      color: #909399;
    }
    .el-button.closedrawerbtn:hover {
      color: #2a75ea;
    }
  }
  .text-bold {
    font-size: 18px;
    font-weight: 700;
    color: #2e405e;
  }
}
.form_field {
  min-height: calc(100% - 52px);
  padding: 52px 0 24px 12px;
  max-width: 100%;
  position: relative;
  flex: 1;
  display: flex;
  font-size: 1rem;
}
.form_left {
  width: 988px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-bottom: 68px;
  padding-left: 2px;
  padding-right: 8px;
  padding: 16px 12px 68px 12px;
  height: 100%;
}

.form_item_left {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;
}
.tit_left {
  color: #2e405e;
  display: block;
  font-size: 16px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 19px;
}
.tit {
  color: #2e405e;
  display: block;
  font-size: 14px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 5px;
}
.items {
  display: flex;
  flex-direction: column;
  margin-bottom: 13px;
  margin-right: 18px;
  .consactzs {
    width: 100%;
    display: flex;
    margin-bottom: 13px;
    flex-direction: column;
  }
}
.form_submit {
  background: #fafbfb;
  border-top: 1px solid #dadee3;
  bottom: 0;
  margin: 0 !important;
  padding: 16px 24px;
  position: absolute;
  width: 100%;
  z-index: 1;
  display: flex;
}
.form_submit_buttons1 {
  /deep/ .el-button {
    margin: 0;
    box-shadow: none !important;
    background-color: #2c7ef8;
    background-image: none;
    color: #fff;
    text-shadow: none;
    width: 60px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 0.28571429rem;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    font-weight: 400;
    text-transform: none;
    text-align: center;
  }
  /deep/ .el-button:hover {
    background-color: #0e68ef;
  }
}
.form_submit_buttons2 {
  margin-left: 8px;
  /deep/ .el-button {
    box-shadow: inset 0 0 0 1px #dadee3 !important;
    color: #4e5969ff !important;
    margin: 0;
    padding: 0;
    border-radius: 0.28571429rem;
    font-weight: 400;
    font-size: 14px;
    text-shadow: none !important;
    text-transform: none;
    background-color: #fff;
    height: 32px;
    border: none;
    cursor: pointer;
    display: inline-block;
    font-style: normal;
    text-align: center;
  }
  /deep/ .el-button:hover {
    background-color: #f5f6f8;
  }
}
.input_w920 {
  width: 924px;
  height: 32px;
}
.input_w460 {
  width: 453px;
  height: 32px;
}
.input_w690 {
  width: 693px;
  height: 32px;
}
.input_w230 {
  width: 218px;
  height: 32px;
}
</style>